import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import { Country, WithMeta } from '@ygoargentina/sdk/api/api.types';

export const listCountries = async () =>
  getGraphQLQueryClient(null).request<WithMeta<Country>>(gql`
    query countries {
      data: countries {
        data {
          id
          name
          provinces {
            id
            name
          }
        }
      }
    }
  `);
